export default __webpack_public_path__ + "images/lower-arch.531a1b4f52d39a6a1dd54106772f7f28.svg";